/*
 * STOPS THIS PHONE KNOWS ARE FINISHED (10 Oct).
 *
 * 9 Oct, Jesus Camargo: UC Davis was delivered at 8:16 pm and the office had
 * it at 8:17. At 8:28 pm, standing at Mercy General with no signal, his phone
 * still showed UC Davis as OPEN -- the route list and the stop screen read the
 * copy of the route saved on the phone, which was older than the delivery. He
 * did Mercy General's whole delivery on the UC Davis screen, and Mercy General
 * was never recorded.
 *
 * The moment the office confirms a stop (sent and accepted), its id is kept
 * here for the rest of the day. The route list shows it as done and the stop
 * screen refuses to open it, even with no signal and an old saved route.
 */

const KEY = 'jw.doneToday';
type Kind = 'completed' | 'skipped';
interface Store { day: string; done: Record<string, { kind: Kind; at: number }> }

const today = () => new Date().toDateString();

function read(): Store {
  try {
    const s = JSON.parse(localStorage.getItem(KEY) ?? 'null') as Store | null;
    if (s && s.day === today() && s.done) return s;
  } catch { /* unreadable: start fresh */ }
  return { day: today(), done: {} };
}

export function markDoneLocally(taskId: string, kind: Kind): void {
  const s = read();
  s.done[taskId] = { kind, at: Date.now() };
  try { localStorage.setItem(KEY, JSON.stringify(s)); } catch { /* storage full: the office check still applies */ }
}

export function doneLocally(taskId: string): { kind: Kind; at: number } | null {
  return read().done[taskId] ?? null;
}
